var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.component},[_c('v-btn',{class:_vm.$style.button,attrs:{"color":"black","width":"234px","height":"53px","outlined":"","large":""},on:{"click":_vm.goToQuote}},[_vm._v(" REQUEST A QUOTE ")]),_c('span',{class:_vm.$style.location},[_vm._v(" Charlotte, NC ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }